import { injectable, inject } from 'inversify';
import type { IReportRepository, SaasMetricsDTO } from '@/domain/repositories/IReportRepository';
import { TYPES } from '@/di/tokens';

@injectable()
export class GetSaasMetricsAction {
  constructor(
    @inject(TYPES.IReportRepository) private reportRepository: IReportRepository
  ) {}

  async execute(): Promise<SaasMetricsDTO> {
    return this.reportRepository.getSaasMetrics();
  }
}
